import * as React from 'react'

import { TabsContext, TabsOnChangeFunction, TabsValue } from './tabsContext'

import * as styles from './tabs.module.css'

interface IProps {
  value: TabsValue
  children: React.ReactNode
  onChange?: TabsOnChangeFunction
}

const Tabs = ({ children, value, onChange = () => {} }: IProps) => (
  <TabsContext.Provider value={{ tabsValue: value, onChange }}>
    <nav className={styles.root} role="tablist">
      {children}
    </nav>
  </TabsContext.Provider>
)

export default Tabs
